export default "__VITE_ASSET__$v1ZYU7ra4yFY22BtcVgkA__"